import React, { Component } from 'react';

export default class extends Component {
  render() {
    return(
      <div className="full-width centered-text max-width-container" style={{padding:"5%", paddingTop:"5%",paddingBottom:"5%"}}>
        {this.props.quote && <h1>{this.props.quote}</h1>}
        {this.props.author && <p className="subheading">{this.props.author}</p>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/lookBookQuoteContainer/index.js